<template>
  <FormLabel2 :mode="mode" :required="required" :ok="ok" :text="text" :error="error" :increased="increased || !modelValue" :class="{'disabled':disabled, 'filled' : modelValue, 'droplisted':true}">
    <HiddenField :name="name" :value="modelValue" />
    <button @click.prevent="$event=>$event.target.focus()" :disabled="disabled || $store.getters.loading" class="formfield formfield_pointer formfield_witharrow" aria-haspopup="listbox" :aria-label="text">{{modelValue}} 
    <svg v-show="!disabled" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 9.5L12 14.5L17 9.5" stroke="#797979" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    </button>
    <DropList :options="options.filter(v=>v)" v-model="val" />
  </FormLabel2> 
</template>

<script>
import FormLabel2 from '@/components/FormLabel2.vue'
import HiddenField from '@/components/HiddenField.vue'
import FormField from '@/mixins/FormField.vue'
import DropList from '@/components/DropList.vue'

export default {
  components: { FormLabel2, HiddenField, DropList },
  mixins: [FormField],
  props: {
    required: { type: Boolean, default: false },
    disabled: {type: Boolean, required: false},
    increased: {type: Boolean, required: false},
    name: {type: String, required: true},
    modelValue: {type: String, default: ''},
    text: {type: String, required: true},
    options: {type: Array, required: true},
    mode: {type: Number, default: 0},
    validation: {type: Function, default: ()=>''}
  },
  data: ()=>({
    error: '',
    tempimmune: false
  }),
  mounted(){
    if (!this.val) {
      this.tempimmune = true
      this.val = this.options[0]
      this.$nextTick(()=>this.tempimmune = false)
    }
  },
  computed:{
    ok(){
      if (!this.modelValue) return false
      return true
    },
    val: {
      get () { return this.modelValue },
      set (value) { this.$emit('update:modelValue', value) },
    },
  },
  watch: {
    modelValue(val, old){
      this.error = ''
      if (val)
      this.error = this.validation(val)
      if (val != old) {
        this.$emit('update:modelValue', val)
        /*
        if (!this.error && !this.tempimmune)
          this.$store.dispatch('callAction', this.name)*/
      }
    },
    options(v) {
      if (v.length && !v.includes(this.modelValue)) {
        this.tempimmune = true
        this.$emit('update:modelValue', v[0])
        this.$nextTick(()=>this.tempimmune = false)         
      }
    }
  }
}
</script>

<style lang="sass">

</style>